import React, { type ReactNode } from 'react';

/**
 * Builds a bold tag converter that converts "<b>" in a defined message
 * to a React/HTML `<b>` tag with the appropriate font-weight and other optional styles.
 *
 * @param styles - Optional styles to apply to the bold tag
 * @returns Record with a `b` key that converts children to a bold tag with the defined styles
 */
export const buildBoldTagIntlConverter = (
  styles: React.CSSProperties = {},
): Record<string, (children: ReactNode) => ReactNode> => ({
  b: (children) => (
    <b style={{ color: 'inherit', fontWeight: 600, ...styles }}>{children}</b>
  ),
});
